export default {
  menus: []
};
